import apiContract from "./apiContract.json";

/** Jedno miejsce budowania adresów widoków Premium. */
const orderPath = (id) => `/premium/orders/${encodeURIComponent(id)}`;
const companyPath = (id) => `/premium/companies/${encodeURIComponent(id)}`;
const adminCompanyPath = (id) =>
  `/premium/admin/companies/${encodeURIComponent(id)}`;
const dictionariesPath = (id, admin = false) =>
  `${admin ? adminCompanyPath(id) : companyPath(id)}/dictionaries`;
const dictionaryPath = (id, kind, admin = false) =>
  `${dictionariesPath(id, admin)}/${encodeURIComponent(kind)}`;
export const premiumPaths = Object.freeze({
  home: "/premium",
  companies: "/premium/companies",
  admin: "/premium/admin/companies",
  newCompany: "/premium/admin/companies/new",
  orders: (id) => `${companyPath(id)}/orders`,
  newOrder: (id) => `${companyPath(id)}/orders/new`,
  dictionaries: dictionariesPath,
  dictionary: dictionaryPath,
  newDictionaryEntry: (id, kind, admin = false) =>
    `${dictionaryPath(id, kind, admin)}/new`,
  editDictionaryEntry: (id, kind, key, admin = false) =>
    `${dictionaryPath(id, kind, admin)}/edit?${new URLSearchParams({ key })}`,
  settings: (id) => `${adminCompanyPath(id)}/settings`,
  members: (id) => `${adminCompanyPath(id)}/members`,
  newMember: (id) => `${adminCompanyPath(id)}/members/new`,
  editMember: (id, userId) =>
    `${adminCompanyPath(id)}/members/${encodeURIComponent(userId)}/edit`,
  adminDictionaries: (id) => dictionariesPath(id, true),
  order: orderPath,
  orderDocuments: (id) => `${orderPath(id)}/documents`,
  issue: (id) => `${orderPath(id)}/issue`,
  preview: (id) => `${orderPath(id)}/preview`,
  certificate: (id) => `${orderPath(id)}/certificate`,
  document: (id, documentId, fromDocuments = false) =>
    `${orderPath(id)}/documents/${encodeURIComponent(documentId)}${fromDocuments ? "?from=documents" : ""}`,
  source: (id, documentId, target) =>
    `${orderPath(id)}/documents/${encodeURIComponent(documentId)}?${new URLSearchParams(target)}`,
});

/** Zachowuje stare zakładki i linki, bez zgadywania firmy po identyfikatorze użytkownika. */
export function legacyPremiumPath({ pathname, search, hash }) {
  const params = new URLSearchParams(search);
  const company = params.get("company");
  const path = pathname
    .replace(/^\/vip(?=\/|$)/, "/premium")
    .replace(/\/$/, "");
  let target;
  if (path.startsWith("/user/vip/") || path === "/premium/admin")
    target = premiumPaths.admin;
  else if (path === "/premium" || path === "/premium/history")
    target = company ? premiumPaths.orders(company) : premiumPaths.home;
  else if (path === "/premium/configuration")
    target = company ? premiumPaths.dictionaries(company) : premiumPaths.home;
  else if (path === "/premium/configuration/test")
    target = company ? premiumPaths.newOrder(company) : premiumPaths.home;
  else target = path;
  params.delete("company");
  return target + (params.size ? `?${params}` : "") + (hash || "");
}

/** Zamienia numer strony z adresu (od 1) na indeks API (od 0). */
export function pageIndex(params) {
  const page = Number(params.get("page") || 1);
  return Number.isInteger(page) &&
    page > 0 &&
    page <= apiContract.maxPageIndex + 1
    ? page - 1
    : 0;
}
